import React from "react";
import "./StepOneAg.scss";
import {useParams} from "react-router-dom";
import moment from "moment";

const StepOneAg = () => {
  const {challenge_name} = useParams();
  return (
    <div className="step-one-ag">
      <Page1 challenge_name={challenge_name} />
      <Page2 />
      <Page3 />
      <Page4 />
      <Page5 />
    </div>
  );
};

export default StepOneAg;

const Page = ({title, children}) => (
  <div className="page">
    {title && <h2>{title}</h2>}
    <div className="content">{children}</div>
  </div>
);
const Page1 = ({challenge_name}) => (
  <Page title="1-Step Account General Service Agreement">
    <p>This Service Agreement ("Agreement") is entered into and effective BETWEEN: with the mailing address (the "Client"), and AND: Equity Edge Analytics LTD, (the "Contractor").</p>
    <h3>Context:</h3>
    <p>A. The client believes that the contractor possesses the necessary qualifications, experience, and capabilities to deliver services.</p>
    <p>B. The contractor agrees to provide these services to the client under the terms outlined in this agreement.</p>
    <h3>Acknowledgment:</h3>
    <p>
      IN CONSIDERATION OF the matters described above and of the mutual benefits and obligations set forth in this agreement, the receipt and sufficiency of which considerations is hereby
      acknowledged, the client and the contractor (individually the "Party" and collectively the "Parties" to this agreement) agree as follows:
    </p>
    <h3>Services Provided:</h3>
    <ol>
      <li>
        The client engages the Contractor to provide the following services ("services"): Trading on a USD <b>{challenge_name}</b> Book.
      </li>
      <li>The service may include other mutually agreed upon tasks.</li>
    </ol>
    <h3>Term of Agreement:</h3>
    <ol start="3">
      <li>The term of this Agreement will begin on the effective date and remain in force until terminated as per the agreement.</li>
      <li>Either party wishing to terminate must provide three days' written notice.</li>
      <li>The contractor holds the right to terminate this Agreement at any time.</li>
      <li>Contractor's obligations cease upon termination, unless otherwise specified.</li>
    </ol>
    <h3>Trading Guidelines:</h3>
    <ol start="7">
      <li>
        By signing, the client agrees to follow: <a href="https://faq.equityedge.io/en/">https://faq.equityedge.io/en/</a> upon breaching any trading restrictions and guidelines set out in the
        previous link may lead to account closure.
      </li>
      <li>
        Use of Any Prohibited Trading strategy listed in the following link will lead to account closure:{" "}
        <a href="https://faq.equityedge.io/en/articles/8953633-prohibited-strategies-onfunded-accounts">https://faq.equityedge.io/en/articles/8953633-prohibited-strategies-onfunded-accounts</a>.
      </li>
      <li>No maximum lot exposure will be implemented within this agreement.</li>
    </ol>
    <h3>Performance:</h3>
    <ol start="10">
      <li>Leverage will be up to 1:50.</li>
    </ol>
  </Page>
);

const Page2 = () => (
  <Page>
    <ol start="11">
      <li>Withdrawal amounts are in USD (United States Dollar), unless otherwise specified.</li>
    </ol>
    <h3>Compensation:</h3>
    <ol start="12">
      <li>
        The Contractor will compensate the Client for the Services as follows (the "Compensation"):
        <ul>
          <li>The Trader will be compensated 80% of profit withdrawals.</li>
          <li>Risk Reviews are at -4% and -6% levels of the trailing balance.</li>
          <li>In an event where funding is pulled at a -4% loss & -6%, no refund of one-time fee will be paid.</li>
        </ul>
      </li>
      <li>
        In the event that this Agreement is terminated by the Client prior to completion of the services but where the services have been partially performed, the contractor will be entitled to pro
        rata payment of the compensation to the date of termination provided that there has been no breach of contract on the part of the Contractor.
      </li>
    </ol>
    <h3>Expenses Reimbursement:</h3>
    <ol start="14">
      <li>Client reimbursed subscription fee on the third profit withdrawal split.</li>
    </ol>
    <h3>Confidentiality:</h3>
    <ol start="15">
      <li>
        Confidential information (the "Confidential Information") refers to any data or information relating to the business of the contractor which would reasonably be considered proprietary to the
        Contractor including, but not limited to, accounting records, business processes, and client records and that is generally known in the industry of the Contractor and where the release of that
        Confidential Information could reasonably be expected to cause harm to the contractor.
      </li>
      <li>
        The Contractor and Client both agree that they will not disclose, divulge, reveal, report or use, for any purpose, any Confidential Information obtained, except as authorised or as required by
        law. The obligations of confidentiality will apply during the term and will survive indefinitely upon termination of this Agreement.
      </li>
      <li>
        All written and oral information and material disclosed or provided by the Client to the Contractor under this Agreement is Confidential Information regardless of whether it was provided
        before or after the date of this Agreement or how it was provided to the Contractor.
      </li>
      <li>
        By signing this agreement, and using the services provided by the contractor, the client agrees that all trading data is owned by the contractor which may be used or sold to 3rd parties at the
        discretion of the contractor.
      </li>
    </ol>
    <h3>Ownership of Intellectual Property:</h3>
    <ol start="19">
      <li>
        All intellectual property related material (the "Intellectual Property") that is developed or produced under this Agreement, will be the property of the Contractor. The Client is granted a
        non-exclusive limited-use licence of this Intellectual Property, including but not limited to all trading data.
      </li>
      <li>Title, copyright and intellectual property rights and distribution rights of the intellectual property remain exclusively with the contractor.</li>
    </ol>
  </Page>
);

const Page3 = () => (
  <Page>
    <h3>Autonomy:</h3>
    <ol start="21">
      <li>
        In providing the Services under the Agreement it is expressly agreed that the Contractor is acting as an independent Contractor connecting the Client to a third-party backer. The Contractor
        and the Client acknowledge that this Agreement does not create a partnership or joint venture between them and is exclusively a contract for services.
      </li>
    </ol>
    <h3>Right of Substitution:</h3>
    <ol start="22">
      <li>
        Except as otherwise provided in this agreement, the Contractor may, at the Contractor's absolute discretion, engage a backer to perform some or all the obligations of the contractor under this
        agreement and the client will not hire third parties to assist with the provision of the services.
      </li>
    </ol>
    <h3>Notice:</h3>
    <ol start="23">
      <li>
        All notices, requests, demands, or other communications required or permitted by the terms of this agreement will be given in writing and delivered to the parties at the following address:
        <ul>
          <li>A.</li>
          <li>Equity Edge Analytics LTD</li>
          <li>Runway East Shoreditch</li>
          <li>52 Tabernacle Street</li>
          <li>London</li>
          <li>United Kingdom</li>
          <li>EC2A 4NJ</li>
          <li>B. support@equityedge.io</li>
          <li>Or to such other address as either Party may from time to time notify the other.</li>
        </ul>
      </li>
    </ol>
    <h3>Indemnification:</h3>
    <ol start="24">
      <li>
        Each Party agrees to indemnify and hold harmless the other Party, and its respective directors, shareholders, affiliates, officers, agents, employees, and permitted successors and assigns
        against any and all claims, losses, damages and liabilities, penalties, punitive damages, expenses, reasonable legal fees and costs of any kind or amount whatsoever, which result from or arise
        out of any act or omission of the indemnifying party, its respective directors, shareholders, affiliates, officers, agents, employee, and permitted successors and assigns that occurs in
        connection with the agreement. This indemnification will survive the termination of this Agreement.
      </li>
    </ol>
  </Page>
);

const Page4 = () => (
  <Page>
    <h3>Modification of Agreement:</h3>
    <ol start="25">
      <li>
        Any amendment or modification of this Agreement or additional obligation assumed by either Party in connection with this Agreement will only be binding if evidenced in writing signed by each
        Party or an authorized representative of each party.
      </li>
    </ol>
    <h3>Time of the Essence:</h3>
    <ol start="26">
      <li>Time is of the essence in this Agreement. No extension or variation of this Agreement will operate as a waiver of this provision.</li>
    </ol>
    <h3>Assignment:</h3>
    <ol start="27">
      <li>The Client will not voluntarily or by operation of law assign or otherwise transfer its obligations under this Agreement without written consent from the Contractor.</li>
    </ol>
    <h3>Entire Agreement:</h3>
    <ol start="28">
      <li>It is agreed that there is no representation, warranty, collateral agreement or condition affecting this agreement except as expressly provided in this agreement.</li>
    </ol>
    <h3>Enurement:</h3>
    <ol start="29">
      <li>This Agreement will enure to the benefit of and be binding on the Parties and their respective heirs, executors, administrators and permitted successors and assigns.</li>
    </ol>
    <h3>Titles/Headings:</h3>
    <ol start="30">
      <li>Headings are inserted for the convenience of the Parties only and are not to be considered when interpreting this Agreement.</li>
    </ol>
    <h3>Gender:</h3>
    <ol start="31">
      <li>Words in the singular mean and include the plural and vice versa. Words in the masculine mean and include the feminine and vice versa.</li>
    </ol>
    <h3>Governing Law:</h3>
    <ol start="32">
      <li>This Agreement will be governed by and construed in accordance with the laws of the Government of the United Kingdom, as this is where Equity Edge Analytics LTD is incorporated.</li>
    </ol>
    <h3>Severability:</h3>
    <ol start="33">
      <li>
        In the event that any of the provisions of this Agreement are held to be invalid or unenforceable in whole or in part, all other provisions will nevertheless continue to be valid and
        enforceable with the invalid or unenforceable parts severed from the remainder of this Agreement.
      </li>
    </ol>
    <h3>Waiver:</h3>
    <ol start="34">
      <li>
        The waiver by either Party of a breach, default, delay, or omission of any of the provisions of the Agreement by the other Party will not be construed as a waiver of any subsequent breach of
        the same or other provisions.
      </li>
    </ol>
    <p>IN WITNESS WHEREOF the parties have duly affixed their signatures under hand and seal on this</p>
  </Page>
);

const Page5 = () => (
  <Page>
    <p>Date: {moment().format("DD-MM-YYYY")}</p>
    <p>Name: Equity Edge Analytics LTD</p>
  </Page>
);
